module.exports = __webpack_public_path__ + "static/media/Asset 2.c4b29c10.png";